<template>
  <div class="totals-statistics mt-1 mb-2">
    <div class="d-flex align-items-center total-jobs col">
      <span class="statistics-heading">
        Statistics for {{ meta.total }} jobs
      </span>
    </div>
    <div class="d-flex align-items-center total-amount col">
      <span>
        ${{ sums.total_amount }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    meta: {
      type: Object,
      default: () => {},
    },
    sums: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
.statistics-heading {
  color: white;
  font-weight: 500;
  font-size: 12px;
}
.total-amount {
  color: white;
  font-weight: 500;
  font-size: 17px;
  flex: 0 0 28.57%;
}
.total-jobs {
  flex: 0 0 71.43%;
}
.totals-statistics {
  display: flex;
  background: #3f4247;
  box-shadow: 0 2px 0 rgba(33, 37, 41, 0.0263604);
  border-radius: 2px;
  justify-content: space-between;
  padding: 7px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/DiscountsStatistics.vue